import { routes } from '@/shared/routes';

import { execute, modelId } from '@/front/actions/utils';
import { DELETE, GET, POST } from '@/front/fetch';
import { LegacyPrimaryContactMatch, openLegacyPrimaryContactModal } from '@/front/legacyPrimaryContactModal';
import { confirmModal } from '@/front/modal';

// section nav restores the section from the hash
const reloadOnContactsSection = () => {
  history.replaceState(null, '', '#contacts');
  location.reload();
};

export const deleteLegacyPrimaryContact = async () => {
  const organisationId = modelId();

  if (!organisationId) return;

  const { res } = await execute(DELETE, routes.organisations.legacyPrimaryContact({ id: organisationId }));

  if (res.ok) {
    reloadOnContactsSection();
  }
};

export const migrateLegacyPrimaryContact = async () => {
  const organisationId = modelId();

  if (!organisationId) return;

  const res = await GET(routes.organisations.legacyPrimaryContactMatches({ id: organisationId }));

  if (!res.ok) return;

  const { matches } = (await res.json()) as { matches: LegacyPrimaryContactMatch[] };

  let body: { individualId?: string; copyEmail?: boolean; copyPhone?: boolean } = {};

  if (matches.length) {
    const choice = await openLegacyPrimaryContactModal(matches);

    if (!choice) return;

    if (choice.action === 'link') {
      body = { individualId: choice.individualId, copyEmail: choice.copyEmail, copyPhone: choice.copyPhone };
    }
  } else if (
    !(await confirmModal(
      'Create a new Individual from the legacy Primary Contact details and make them the Primary Contact?',
      'Migrate',
    ))
  ) {
    return;
  }

  const { res: migrateRes } = await execute(
    POST,
    routes.organisations.legacyPrimaryContactMigrate({ id: organisationId }),
    body,
  );

  if (migrateRes.ok) {
    reloadOnContactsSection();
  }
};
